import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {HealthTasks} from '../models/health-tasks.model';

@Injectable()
export class HealthTasksAdapter implements IAdapter<HealthTasks> {
  adaptToModel(resp: any): HealthTasks {
    const healthTask: HealthTasks = {...resp};

    if (resp.possibleValues) {
      healthTask.valuesArray = JSON.parse(resp.possibleValues).map(item => {
        return {
          label: JSON.stringify(item),
          value: item,
        };
      });
    }
    return healthTask;
  }
  adaptFromModel(data: HealthTasks): any {
    return data;
  }
}
